// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_HVm","cls2":"common-cls2_b8C common-cls1_HVm"};